import type { DistributionListFormValues } from './DistributionLists.types.ts';

export const getDistributionListValues = (
  data: DistributionListFormValues & { recipients: string[] },
) => ({
  id: data?.id || null,
  name: data?.name || '',
  recipients: data?.recipients?.join(', ') || '',
});

export const getDistributionListData = (values: DistributionListFormValues) => ({
  name: values.name,
  recipients: values.recipients?.split(','),
});
